
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "dailyuse-book",
components: {
XHeader
},
data(){
return{
title:"生活用品预订",
goods:[
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:false,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:true,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:true,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:false,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:true,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:false,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:true,
},
{
img:"../../static/img/shose.png",
name:"军训专用帆布鞋",
price:"100",
isBook:false,
},
]
}
},
methods:{
gotoconfirm(){
this.$router.push('/ConfirmOrder');
}
}
}



// WEBPACK FOOTER //
// ./src/components/DailyuseBook.vue